export const requestProxy: [unknown, string] = [
  {
    priority: 0,
    requestOptions: (args: {}) => ({ ...args, credentials: 'include' }),
  },
  'request-proxy',
];
